import React from 'react';

export const SidebarHeader = ({ title, closeAction, options }) => (
    <div className="bg-gray-100 w-full p-4 absolute top-0 right-0 z-30 lg:shadow">
        <div className="relative pl-8 text-black text-xl font-semibold">
            <div className="bg-transparent text-black/50 text-md cursor-pointer absolute top-1/2 left-0 z-10 -translate-y-1/2 transition all hover:text-black" onClick={closeAction}>
                <span className="icon icon-close"></span>
            </div>
            {title}
            {options}
        </div>
    </div>
);